import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M7 12C7 13.381 5.881 14.5 4.5 14.5C3.119 14.5 2 13.381 2 12C2 10.619 3.119 9.5 4.5 9.5C5.881 9.5 7 10.619 7 12Z"
      fill="currentColor"
    />
    <path
      d="M22 12C22 13.381 20.881 14.5 19.5 14.5C18.119 14.5 17 13.381 17 12C17 10.619 18.119 9.5 19.5 9.5C20.881 9.5 22 10.619 22 12Z"
      fill="currentColor"
    />
    <path
      d="M14.5 12C14.5 13.381 13.381 14.5 12 14.5C10.619 14.5 9.5 13.381 9.5 12C9.5 10.619 10.619 9.5 12 9.5C13.381 9.5 14.5 10.619 14.5 12Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'MoreHorizontal');

export default Icon;
